export const enum BodySchemaGeneralPain {
  PULSE = 'pulsatile', // Pulsatile
  ELECTRIC_SHOCK = 'electric_shock', // En éclairs
  STAB = 'stab', // Coups de poignard,
  SHARP = 'sharp', // Vive,
  CRAMP = 'cramp', // A type de crampe
  GNAW = 'gnaw', // Qui ronge,
  BURN = 'burn', // Chaude/brûlante
  SHOOTING = 'shooting', // Sourde
  HEAVINESS = 'heaviness', // Lourde
  CONTACT_SENSITIVE = 'contact_sensitive', // Sensible au contact
  TEARING = 'tearing' // Déchirante
}

export const enum BodySchemaMouthPainLocation {
  LIPS = 'lips', // Lèvres
  TONGUE = 'tongue', // Langue
  PALATE = 'palate', // Palais
  GUMS = 'gums', // Gencives
  TEETH = 'teeth', // Dents
  INSIDE_CHEEKS = 'inside_cheeks', // Intérieur des joues
  THROAT = 'throat' // Gorge
}

export const enum BodySchemaPelvicPainLocation {
  BUTTOCKS = 'buttocks', // Fesses
  ANUS = 'anus', // Anus
  PUBIS = 'pubis', // Pubis
  LABIA_MAJORA = 'labia_majora', // Grandes lèvres
  VULVA = 'vulva', // Vulve
  CLITORIS = 'clitoris', // Clitoris
  VAGINAL_OPENING = 'vaginal_opening', // Intérieur du vagin
  TESTICULE = 'testicule', // Testilcule(s)
  PENIS = 'penis', // Pénis
  GLANS_PENIS = 'glans_penis' // Gland du pénis
}

export interface BodySchemaData {
  color: string;
  useSurfacePain: boolean;
}

export interface BodySchemaZone {
  idx: number;
  value: BodySchemaZoneValue;
}

export interface BodySchemaZoneBasic {
  idx: number;
  isBack: boolean;
}

export interface BodySchemaZoneValue {
  type: 0 | 1;
  weight: 0 | 1 | 2 | 3 | 4;
}

export type BodySchemaFace = 'FRONT' | 'BACK';

export type BodySchemaEditingMode = 'DELETE' | BodySchemaZoneValue;
